import React from 'react';
import { debounce } from 'throttle-debounce';
import Download from '@/pages/opinion/components/FilterBoxCommon/filters/download';
import { Button, LoadingTip } from 'tea-component';
import { useIntl } from 'umi';
import DOMPurify from 'dompurify';
const debounceTime = 100;
export function HeadingsNavigator({
  list,
  wholeGameInfo,
  handleNavigatorScroll,
  contentRef,
  navigator,
}: {
  list: Array<any>;
  wholeGameInfo: any;
  handleNavigatorScroll?: any;
  contentRef: any;
  navigator: any;
}) {
  if (!list || !Array.isArray(list) || list?.length === 0) {
    return null;
  }

  return (
    <ul
      className="dbo-markdown-preview-nav"
      style={{
        top:
          wholeGameInfo?.show_warn ||
          wholeGameInfo?.edition_unified_id === 'e11000000297'
            ? 265
            : 240,
      }}
    >
      {list.map((item) => (
        <li
          className={`dbo-markdown-preview-nav-depth-${item.level} ${
            navigator === item.slug ? 'active' : ''
          }`}
          key={item.slug}
          onClick={debounce(debounceTime, () => {
            handleNavigatorScroll(item.slug, contentRef, 10);
          })}
        >
          <a>{item.text}</a>
        </li>
      ))}
    </ul>
  );
}

export function DownloadButton({
  onClick,
  rendering,
  renderText,
  markdownRef,
}: {
  onClick: () => void;
  rendering: boolean;
  renderText: string;
  markdownRef: any;
}) {
  return (
    <div className="dbo-gpt-markdown-main">
      {/* 禁用时加 disabled true */}
      <Download onClick={onClick} state={rendering ? 'loading' : ''}></Download>
      <div
        className="markdown-body"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(renderText) }}
        ref={markdownRef}
      ></div>
    </div>
  );
}


export function LoadingTipText() {
  return (
    <LoadingTip
      loadingText=""
      style={{
        marginLeft: '48%',
        position: 'relative',
        marginTop: '30%',
      }}
    />
  );
}

export function EmptyBody({
  hasDataTime,
  handleGotoHasMarkdown,
  children,
  empty,
}: {
  hasDataTime: { start_time: string; end_time: string };
  handleGotoHasMarkdown: () => void;
  children: any;
  empty: boolean;
}) {
  const { formatMessage } = useIntl();

  const getRefreshNewTimeElement = (text: string) => (
    <Button
      type="link"
      style={{ paddingLeft: 5 }}
      onClick={handleGotoHasMarkdown}
    >
      {text}
    </Button>
  );

  if (empty) {
    return (
      <div className="dbo-markdown-preview-empty">
        {formatMessage({
          id: 'No GPT Report under current filter settings.',
        })}

        {hasDataTime.start_time
          ? getRefreshNewTimeElement(
              formatMessage({
                id: 'Click to view recent report',
              }),
            )
          : ''}
      </div>
    );
  }

  return children;
}
